import { useParams, Link, Navigate } from "react-router-dom";
import { AppLayout } from "@/components/layout/AppLayout";
import { getArticleById } from "@/data/launchKitArticles";
import { articleContent } from "@/data/launchKitContent";
import { ArrowLeft, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function LaunchKitArticle() {
  const { articleId } = useParams<{ articleId: string }>();
  const article = articleId ? getArticleById(articleId) : undefined;
  const content = articleId ? articleContent[articleId] : undefined;

  // Redirect if article doesn't exist or is locked
  if (!article || article.isLocked) {
    return <Navigate to="/app/launch-kit" replace />;
  }

  return (
    <AppLayout>
      <div className="p-4 md:p-8 max-w-4xl">
        {/* Back Button */}
        <Link to="/app/launch-kit">
          <Button variant="ghost" className="mb-6 -ml-2">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Launch Kit
          </Button>
        </Link>

        {/* Article Header */}
        <div className="mb-8">
          <Badge variant="secondary" className="mb-3">
            {article.category === "getting-started" ? "Getting Started" : "Advanced"}
          </Badge>
          <h1 className="text-3xl font-bold text-foreground mb-3">{article.title}</h1>
          <p className="text-lg text-muted-foreground mb-4">{article.description}</p>
          <div className="flex items-center gap-1 text-sm text-muted-foreground">
            <Clock className="h-4 w-4" />
            <span>{article.readTime} read</span>
          </div>
        </div>

        {/* Article Content */}
        <div className="bg-card rounded-lg border p-6 md:p-8">
          {content || (
            <p className="text-muted-foreground">Content coming soon...</p>
          )}
        </div>
      </div>
    </AppLayout>
  );
}
